import { createContext, useContext } from 'react';

const GridViewerPendingContext = createContext(0);

export const GridViewerPendingProvider = GridViewerPendingContext.Provider;
export const useGridViewerPendingCount = () => useContext(GridViewerPendingContext);
